import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import RimMark from "@/components/RimMark";
import { LINKS, NAV } from "@/lib/links";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-rim-night/85 backdrop-blur-xl border-b border-rim/15 shadow-[0_8px_30px_-12px_rgba(124,58,237,0.5)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 h-14 md:h-20 flex items-center justify-between gap-3">
        <RimMark variant="dark" size="md" />

        <nav className="hidden md:flex items-center gap-1" data-testid="primary-nav">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.href.replace("#", "")}`}
              className="px-3.5 py-2 text-sm font-medium rounded-full text-white/75 hover:text-white hover:bg-white/10 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={LINKS.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-book-call-btn"
            className="inline-flex items-center gap-1.5 bg-rim hover:bg-rim-hover text-white text-[13px] font-semibold px-4 py-2 rounded-full transition-all duration-300 hover:shadow-[0_8px_24px_rgba(168,85,247,0.5)]"
          >
            <MessageCircle className="h-3.5 w-3.5" />
            Contattaci
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="Apri menu"
            data-testid="mobile-menu-toggle"
            className="md:hidden h-10 w-10 grid place-items-center rounded-full bg-white/10 text-white border border-white/15"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-rim-night border-t border-white/10"
            data-testid="mobile-menu"
          >
            <div className="px-5 py-4 flex flex-col gap-1">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${n.href.replace("#", "")}`}
                  className="px-4 py-3 text-base font-medium text-white rounded-xl hover:bg-white/10"
                >
                  {n.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
